<template>
    <div class="betSlip comboParlay notranslate">
        <div class="betSlip-area">
            <div class="betSlip-title">
                <span v-on:click="hideBetSlip">
                    <SvgIcon iconName="systemIcon_back" />
                </span>

                <div class="betSlip-title-name">
                    {{ i18n.t('bottom_function_bet_slip_EURO') }}
                </div>
                <div class="betSlip-title-mixParlay-removeAll ParlaySlip_Btn_RemoveAll" v-on:click="removeBetSlip">
                    <SvgIcon iconName="systemIcon_removeAll" />
                </div>
            </div>
            <div
                class="betSlip-scrollContent"
                v-bind:class="{ _stakePadShow: !isShowStakePad }"
            >
                <div class="betSlip-ticketArea">
                    <TransitionGroup name="list-complete">
                        <div
                            v-for="(single, key) in betSlip.tickets"
                            v-bind:key="key"
                            class="list-complete-item"
                        >
                            <EuroSingleTicket
                                v-bind:balance="balance"
                                v-bind:singleTicket="single"
                                v-bind:isMixParlay="true"
                                v-on:refreshTicket="refresh(false, true)"
                                v-on:removeTicket="removeTicketOrBetSlip(`${single.oddsId}-${single.option}`)"
                            />
                            <Message
                                v-if="single.message.key"
                                status="error"
                                v-bind:messageKey="single.message.key"
                                v-bind:messageData="single.message.data"
                                class="ticket-error-message"
                            />
                        </div>
                    </TransitionGroup>

                    <TransitionGroup name="fade">
                        <div
                            v-for="n in countOfAddMore"
                            v-bind:key="n"
                            class="betSlip-addMore betSlip-addMoreMp"
                            v-on:click="hideBetSlip"
                        >
                            <ParlayTicketCountInsufficientMessage v-if="n === 1" />
                            <span v-else>+</span>
                        </div>
                    </TransitionGroup>
                    <div
                        v-if="isValidSubBetCount && ticketCount < 11"
                        class="betSlip-addMore betSlip-addMoreMp"
                        v-on:click="hideBetSlip"
                    >
                        <span>+</span>
                    </div>

                    <div v-if="isValidSubBetCount" class="betSlip-info safeAreaBottom">
                        <div class="betSlip-info-totalOdds">
                            <span>{{ i18n.t('betSlip_totalBets') }}:</span>
                            <span>{{ totalBetCount }}</span>
                        </div>
                        <div class="betSlip-info-totalOdds">
                            <span>{{ i18n.t('betSlip_totalStake') }}:</span>
                            <span>
                                {{ totalParlayStakeDisplay }}
                            </span>
                        </div>
                        <div class="betSlip-info-maxPayout">
                            <span>{{ i18n.t('payout_EURO') }}:</span>
                            <span class="notranslate betSlip-info-maxPayout-amount">
                                {{ totalPayOutWithComboParlay }}
                            </span>
                        </div>
                        <PlaceBet
                            class="combo-placeBet"
                            v-bind:stake="stake"
                            v-bind:isDisableBtn="isDisablePlaceBet"
                            v-bind:balance="balance"
                            v-bind:minBet="betSlip.min"
                            v-bind:price="price"
                            v-on:placeBet="placeBet"
                            v-on:changeStake="setStake"
                        />
                        <StakePad
                            v-bind:stake="stake"
                            v-bind:balance="balance"
                            v-bind:minBet="betSlip.min"
                            v-bind:maxBet="betSlip.max"
                            v-bind:currency="customerInfo.currency"
                            v-on:changeStake="setStake"
                        />
                        <SwitchAcceptAnyOddsValue
                            v-if="!customerInfo.isAcceptAnyOdds"
                            class="combo-acceptAnyOdds"
                        />
                    </div>
                </div>
                <div v-if="countOfAddMore === 0" class="combo">
                    <h2 class="combo-title">
                        {{ i18n.t('betSlip_comboParlay_EURO') }}
                        <span
                            v-if="!isValid2MpSubBets"
                            class="combo-info"
                            v-on:click="setShowComboInfo"
                        >
                            i
                        </span>
                    </h2>
                    <div
                        v-for="(option, index) in comboParlayOptions"
                        v-bind:key="index"
                        class="combo-item"
                        v-bind:class="{ _selected: option.selected }"
                        v-on:click="addOrRemoveSelectedCombo(option.key)"
                    >
                        <span class="combo-item-checkbox">
                            <SvgIcon iconName="systemIcon_checked" />
                        </span>
                        <div>
                            {{ option.option }}
                            <SvgIcon
                                v-if="option.canCashOut"
                                class="combo-item-cash-out"
                                iconName="sportIcon_cashOut"
                            />
                            <span v-if="option.betCount > 1">({{ i18n.t('betSlip_n_bets', { n: option.betCount }) }})</span>
                            <span v-else class="combo-odds">@{{ toFixedDecimalPoint(option.odds, 3) }}</span>
                        </div>
                        <div class="combo-payout">
                            <p>{{ i18n.t('payout_EURO') }}</p>
                            {{ formatMoneyWithDecimal(option.payout) }}
                        </div>
                    </div>
                </div>
                <ComboParlayInfoPopup v-if="showComboInfo" v-on:close="setShowComboInfo" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed, defineComponent, onBeforeUnmount, onMounted, ref, watch } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import SwitchAcceptAnyOddsValue from '@/components/SwitchAcceptAnyOddsValue.vue';
    import ComboParlayInfoPopup from '@/components/betSlip/ComboParlayInfoPopup.vue';
    import EuroSingleTicket from '@/components/betSlip/EuroSingleTicket.vue';
    import ParlayTicketCountInsufficientMessage from '@/components/betSlip/ParlayTicketCountInsufficientMessage.vue';
    import PlaceBet from '@/components/betSlip/PlaceBet.vue';
    import StakePad from '@/components/betSlip/StakePad.vue';
    import Message from '@/components/common/Message.vue';
    import type { IBetSlipCashOut } from '@/interface/IBetSlipCashOut';
    import { BetSlipState, RoutePage } from '@/interface/enum';
    import { useParlayCashOut } from '@/libraries/composables/useBetSlipCashOut';
    import { isValidComboBet } from '@/libraries/helpers/comboParlayHelper';
    import { i18n } from '@/libraries/i18n';
    import { isMainMarket } from '@/libraries/marketGroupHelper';
    import { enableScrolling } from '@/libraries/utils/dom';
    import { toFixedDecimalPoint } from '@/libraries/utils/text';
    import { useAccountStore } from '@/stores/accountStore';
    import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';
    import { useParlayBetSlipStore } from '@/stores/betSlip/parlayBetSlipStore';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';
    import SvgIcon from '@/svg/SvgIcon.vue';

    export default defineComponent({
        name: 'EuroBigBetSlip',
        components: {
            ComboParlayInfoPopup,
            ParlayTicketCountInsufficientMessage,
            EuroSingleTicket,
            PlaceBet,
            StakePad,
            SwitchAcceptAnyOddsValue,
            SvgIcon,
            Message,
        },
        setup() {
            const {
                betSlip,
                isPlacingBet,
                ticketCount,
                totalBetCount,
                comboTotalOdds,
                isValid2MpSubBets,
                isValidSubBetCount,
                comboOdds,
                countOfAddMore,
                price,
                totalParlayStakeDisplay,
                stake,
                subBets,
                totalPayOutWithComboParlay,
            } = storeToRefs(useParlayBetSlipStore());
            const {
                openTicket,
                placeBet,
                setStake,
                resetSelectedCombo,
                removeBetSlip,
                removeTicketOrBetSlip,
            } = useParlayBetSlipStore();

            const { isShowStakePad } = storeToRefs(useBetSlipStore());
            const { customerInfo, balance } = storeToRefs(useAccountStore());
            const { formatMoneyWithDecimal } = useAccountStore();

            const isDisablePlaceBet = computed(() => {
                if (isPlacingBet.value) return true;
                if (!isValidComboBet(betSlip.value, isValidSubBetCount.value)) return true;

                if (balance.value === null) return false;
                if (balance.value < betSlip.value.min) return true;

                return Math.floor(balance.value) <= 0;
            });

            const { cashOutSubBetMinCount } = storeToRefs(useFeatureToggleStore());

            const subBetCashOuts = computed<IBetSlipCashOut[]>(() => subBets.value.map(bet => ({
                sportType: bet.sportType,
                isMainMarket: isMainMarket(bet.marketGroup.id),
                leagueId: bet.leagueId,
                marketType: bet.marketType,
            })));
            const { isDisplayCashOutIcon: allTicketSupportCashOut } = useParlayCashOut(subBetCashOuts);

            const comboParlayOptions = computed(() => {
                if (ticketCount.value > 8) {
                    const comboTotalOdd = comboTotalOdds.value[ticketCount.value];

                    return [{
                        option: i18n.t('betSlip_comboParlay_option_n', { n: ticketCount.value }),
                        odds: comboTotalOdd,
                        betCount: comboOdds.value[ticketCount.value].length,
                        payout: comboTotalOdd * stake.value,
                        key: ticketCount.value,
                        selected: betSlip.value.selectedCombo.indexOf(ticketCount.value) > -1,
                        canCashOut: allTicketSupportCashOut.value,
                    }];
                }

                type ComboOption = {
                    option: string;
                    odds: number;
                    betCount: number;
                    payout: number;
                    key: number;
                    selected: boolean;
                    canCashOut: boolean;
                };

                const result: ComboOption[] = [];
                for (let i = 2; i <= ticketCount.value; i++) {
                    const comboTotalOdd = comboTotalOdds.value[i];

                    result.push({
                        option: i <= 3 ? i18n.t(`betSlip_comboParlay_option_${i}`) : i18n.t('betSlip_comboParlay_option_n', { n: i }),
                        odds: comboTotalOdd,
                        betCount: comboOdds.value[i].length,
                        payout: comboTotalOdd * stake.value,
                        key: i,
                        selected: betSlip.value.selectedCombo.includes(i),
                        canCashOut: allTicketSupportCashOut.value && i >= cashOutSubBetMinCount.value,
                    });
                }
                return result;
            });

            const showComboInfo = ref(false);
            function setShowComboInfo() {
                showComboInfo.value = !showComboInfo.value;
            }

            const { setBetSlipState } = useBetSlipStore();

            const selectedTickets = computed(() => Object.keys(betSlip.value.tickets));

            const route = useRoute();
            const router = useRouter();
            function hideBetSlip() {
                setBetSlipState(BetSlipState.Mini);
                resetSelectedCombo();

                if (route.name !== RoutePage.Main && route.name !== RoutePage.MainBySport) {
                    router.push({ name: RoutePage.Main });
                }
            }

            function addOrRemoveSelectedCombo(key: number) {
                const index = betSlip.value.selectedCombo.indexOf(key);

                if (index > -1) {
                    betSlip.value.selectedCombo.splice(index, 1);
                } else {
                    betSlip.value.selectedCombo.push(key);
                }
            }

            const ticks = ref(0);
            const isRefreshing = ref(false);
            async function refresh(isFirstTime: boolean, force: boolean) {
                ticks.value = 0;

                if (force) {
                    await realRefresh(isFirstTime);
                } else {
                    fakeRefresh();
                }
            }

            function fakeRefresh() {
                refreshAnimation();
            }

            async function realRefresh(isFirstTime: boolean) {
                refreshAnimation();

                await openTicket(isFirstTime);
            }

            function refreshAnimation() {
                isRefreshing.value = true;
                setTimeout(() => {
                    isRefreshing.value = false;
                }, 1000);
            }

            async function tick() {
                ticks.value++;
                if (ticks.value >= 10) {
                    await refresh(false, false);
                }
            }

            function scrollToBottom() {
                const scrollDiv = document.getElementsByClassName('betSlip-scrollContent')[0];
                scrollDiv?.scrollTo(0, scrollDiv.scrollHeight);
            }

            onMounted(async () => {
                scrollToBottom();
                window.eventEmitter.on('tick', tick);
                await refresh(true, true);
            });

            onBeforeUnmount(() => {
                window.eventEmitter.off('tick', tick);
                enableScrolling();
            });

            watch(selectedTickets, async () => {
                await refresh(true, true);
            });

            return {
                i18n,
                hideBetSlip,
                removeBetSlip,
                removeTicketOrBetSlip,
                isShowStakePad,
                betSlip,
                refresh,
                countOfAddMore,
                isValid2MpSubBets,
                isValidSubBetCount,
                ticketCount,
                totalBetCount,
                totalParlayStakeDisplay,
                totalPayOutWithComboParlay,
                customerInfo,
                stake,
                isDisablePlaceBet,
                placeBet,
                setStake,
                showComboInfo,
                setShowComboInfo,
                comboParlayOptions,
                addOrRemoveSelectedCombo,
                toFixedDecimalPoint,
                formatMoneyWithDecimal,
                balance,
                price,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/components/betSlipComboParlay";
</style>
